import { domainsConstants } from "../constants/action.constants";
import { domainService } from "../services/domains.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const domainActions = {
  addDomain,
  getAllDomains,
  getDomain,
  resetDomain,
  resetAddDomain
};

function getAllDomains() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await domainService.getAllDomains();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_DOMAINS
        )
      );
    }
  };

  function request() {
    return { type: domainsConstants.GET_DOMAINS_REQUEST };
  }
  function success(response) {
    return { type: domainsConstants.GET_DOMAINS_SUCCESS, response };
  }
  function failure(error) {
    return { type: domainsConstants.GET_DOMAINS_FAILURE, error };
  }
}

function getDomain(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await domainService.getDomain(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_DOMAIN}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: domainsConstants.VIEW_DOMAIN_REQUEST, id };
  }
  function success(response) {
    return { type: domainsConstants.VIEW_DOMAIN_SUCCESS, response };
  }
  function failure(error) {
    return { type: domainsConstants.VIEW_DOMAIN_FAILURE, error };
  }
}

function addDomain(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await domainService.addDomain(requestBody);
      response && dispatch(success(response));
      dispatch(getAllDomains());
      if (requestBody.id) {
        history.push(routeConstants.DOMAINS.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_DOMAIN : message.ADD_DOMAIN
        )
      );
      dispatch(resetAddDomain());
      dispatch(resetDomain());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_DOMAIN : message.ADD_DOMAIN
        )
      );
    }
  };

  function request(requestBody) {
    return { type: domainsConstants.ADD_DOMAIN_REQUEST, requestBody };
  }
  function success(response) {
    return { type: domainsConstants.ADD_DOMAIN_SUCCESS, response };
  }
  function failure(error) {
    return { type: domainsConstants.ADD_DOMAIN_FAILURE, error };
  }
}

function resetDomain() {
  return { type: domainsConstants.VIEW_DOMAIN_RESET };
}

function resetAddDomain() {
  return { type: domainsConstants.ADD_DOMAIN_RESET };
}
